/* eslint-disable @next/next/no-img-element */
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getMainDealThumbCountFromBreakpoint } from '../../helpers/deals';
import { useScreenBreakpoint, isMobileViewport } from '../../helpers/screen';
import { parseWowcherPath } from '../../helpers/url';
import CarouselBlock from './shared-components/carousel/CarouselBlock';
import TravelCarouselBlock from './shared-components/carousel-travel/CarouselBlock';

const MainDealCarousel = ({
  deal = {},
  onClick,
  isClosed = false,
  disableClickAction = false,
  imageVariant,
  imageVariantIndex,
  isProductPage,
}) => {
  const breakpoint = useScreenBreakpoint();
  const thumbCount = getMainDealThumbCountFromBreakpoint(breakpoint);
  const router = useRouter();
  const { details } = parseWowcherPath(router.asPath);
  const [travel, setTravel] = useState(false);

  useEffect(() => {
    setTravel(details.isTravel && !isMobileViewport());
  }, [details.isTravel, breakpoint]);

  if (travel) {
    return (
      <TravelCarouselBlock
        deal={deal}
        disableClickAction={disableClickAction}
        isClosed={isClosed}
        lazy={false}
        onClick={onClick}
        showControls
        showImageOverlays
        thumbCount={thumbCount}
      />
    );
  }

  return (
    <CarouselBlock
      deal={deal}
      disableClickAction={disableClickAction}
      imageVariant={imageVariant}
      imageVariantIndex={imageVariantIndex}
      isClosed={isClosed}
      isProductPage={isProductPage}
      lazy={false}
      onClick={onClick}
      showControls
      showImageOverlays
      thumbCount={thumbCount}
    />
  );
};

MainDealCarousel.propTypes = {
  deal: PropTypes.object,
  disableClickAction: PropTypes.bool,
  imageVariant: PropTypes.string,
  imageVariantIndex: PropTypes.number,
  isClosed: PropTypes.bool,
  isProductPage: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MainDealCarousel;
